import { render, staticRenderFns } from "./InvestmentDetails.vue?vue&type=template&id=2f03506b&"
import script from "./InvestmentDetails.vue?vue&type=script&lang=js&"
export * from "./InvestmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentDetails.vue?vue&type=style&index=0&id=2f03506b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./InvestmentDetails.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports